import { render } from "./tipline.vue?vue&type=template&id=0fd0fead&scoped=true"
import script from "./tipline.vue?vue&type=script&lang=js"
export * from "./tipline.vue?vue&type=script&lang=js"

import "./tipline.vue?vue&type=style&index=0&id=0fd0fead&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0fd0fead"

export default script